import { Badge } from '@/components/ui/badge';
import { Format } from '@/hooks/useCampaigns';
import { cn } from '@/utils/shadcn';

const formatStyles = {
  [Format.VIDEO]:
    'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  [Format.CAROUSEL_ALBUM]:
    'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
  [Format.IMAGE]:
    'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
} as const;

type EventBadgeProps = {
  format: Format;
  className?: string;
};

export const EventBadge = ({ format, className }: EventBadgeProps) => {
  const text = format.split('_').map((word) => word.toUpperCase())[0];

  return (
    <Badge className={cn('text-xs', formatStyles[format], className)}>
      {text}
    </Badge>
  );
};
